import domReady from '@roots/sage/client/dom-ready';
import './account';
import './calculator';
import './favourite';
import './filter-product';
import './header';
import './home';
import './infinite-scrolling.js';
import './pc2b';
import './product-card';
import './search';
import './single-product';

/**
 * Application entrypoint
 */
domReady(async () => {
  // ...
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
